import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { pageview } from '@/lib/analytics'

export function usePageview() {
  const location = useLocation()
  useEffect(() => {
    pageview({
      path: location.pathname,
      search: location.search,
      hash: location.hash,
    })
  }, [location.pathname, location.search, location.hash])
}


